const initPricingIndustries = () => {
	const industries = document.querySelectorAll('.pricing-block-industries li');
	const pricingTables = document.querySelectorAll('.pricing-columns .wp-block-column');

	/**
	 * Get Recommended Plan based on the plans array.
	 *
	 * @param {Array} plans Plans Array.
	 * @returns {string} The recommended plan.
	 */
	const getRecommendedPlan = (plans) => {
		// Define plans weightage based rule to recommend plan.
		const planWeightage = {
			free: 0,
			business: 1,
			premium: 2,
			growth: 3
		};
		// Check plans array and return only the highest weightage plan.
		const recommendedPlan = plans.reduce((a, b) => (planWeightage[a] > planWeightage[b] ? a : b));
		return recommendedPlan;
	};

	const industryToggleHandler = (selectedIndustry) => {
		pricingTables.forEach((table) => {
			const planNameElement = table.querySelector('[class*=pricing-front-]');
			if (planNameElement) {
				const planNameMatch = planNameElement.className.match(/pricing-front-(.*?)__/);
				const isBestDeal = planNameMatch && planNameMatch[1] && selectedIndustry.includes(planNameMatch[1]);
				const bestDealHeading = table.querySelector('.best-deal-heading');
				const recommendedPlan = getRecommendedPlan(selectedIndustry);
				if (isBestDeal) {
					// Check if the current plan is recommended plan.
					if (recommendedPlan === planNameMatch[1]) {
						if (!bestDealHeading) {
							const bestDeal = document.createElement('p');
							bestDeal.textContent = 'Recommended for you!';
							bestDeal.classList.add('best-deal-heading', 'pe-industry-added');
							table.prepend(bestDeal);
						} else {
							bestDealHeading.classList.add('pe-industry-added');
							bestDealHeading.textContent = 'Recommended for you!';
						}

						table.classList.add('best-deal-column');
					} else if (bestDealHeading) {
						bestDealHeading.remove();
						table.classList.remove('best-deal-column');
					}

					table.classList.add('highlight');
					table.style.opacity = '1';
					table.style.pointerEvents = 'auto';
					// Bring table in viewport only if it is mobile screens.
					if (window.innerWidth < 768) {
						table.scrollIntoView({ behavior: 'smooth' });
					}
				} else {
					if (bestDealHeading) {
						bestDealHeading.remove();
					}

					table.classList.remove('highlight', 'best-deal-column');
					table.style.opacity = selectedIndustry[0] === 'all' ? '1' : '0.2';
					table.style.pointerEvents = selectedIndustry[0] === 'all' ? 'auto' : 'none';
					if (selectedIndustry[0] === 'all') {
						const premiumColumn = table.querySelector('[class*=pricing-front-premium]');
						if (premiumColumn) {
							table.classList.add('best-deal-column');
							const premiumBestDeal = document.createElement('p');
							premiumBestDeal.textContent = 'Best Deal';
							premiumBestDeal.classList.add('best-deal-heading');
							table.prepend(premiumBestDeal);
						}
					}
				}
			}
		});
	};

	industries.forEach((industry) => {
		industry.addEventListener('click', function () {
			const selectedIndustry = this.dataset.plansFor.split(',');
			industries.forEach((i) => i.classList.remove('active'));
			this.classList.add('active');
			industryToggleHandler(selectedIndustry);
		});
	});
};

const pricingIndustries = () => {
	if ('loading' === document.readyState) {
		// The DOM has not yet been loaded.
		// eslint-disable-next-line @wordpress/no-global-event-listener
		document.addEventListener('DOMContentLoaded', initPricingIndustries);
	} else {
		// The DOM has already been loaded.
		initPricingIndustries();
	}
};

export default pricingIndustries;
